import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  width: 100%;
`;

export const RecordingBar = styled.div`
  ${({ theme, $whiteBackground }) => css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 8px 16px;
    width: 100%;
    height: 36px;
    border-radius: 1000px;
    background-color: ${$whiteBackground ? theme.v2.colors.neutral.highPure : theme.v2.colors.neutral.highLight};
    min-width: ${$whiteBackground ? '357px' : 'unset'};

    font-family: ${theme.v2.font.family.primary};
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};

    @media (max-width: ${theme.v2.breakpoints.md}) {
      min-width: ${$whiteBackground ? '200px' : 'unset'};
    }
  `}
`;

export const RecordFeedbackLabel = styled.span`
  display: block;
`;

export const RecordingTime = styled.span`
  display: block;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const Button = styled.button`
  ${({ theme, $type, $isLoading }) => css`
    all: unset;
    background-color: ${$type === 'cancel' ? theme.v2.colors.feedback.problemLight : theme.v2.colors.brand.primaryMedium};
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: ${!$isLoading ? '50%' : '1000px'};
    height: 36px;
    padding: 0px;
    width: ${!$isLoading ? '36px' : '56px'};
    cursor: pointer;
  `}
`;

export const SkeletonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
